import { Container, Paper, TableRow, TableCell, Button, Box } from '@mui/material'
import { styled } from '@mui/system'

export const StyledContainer = styled(Container)({
  marginTop: 60,
  paddingBottom: 60
})

export const StyledPaper = styled(Paper)({
  padding: 40
})

export const HeaderContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: 24,
  padding: '0 40px',
  gap: 16,
  flexWrap: 'wrap',
  '& > *:first-child': {
    flex: '0 0 auto'
  }
})

export const FiltersContainer = styled(Box)({
  display: 'flex',
  gap: 8,
  alignItems: 'center',
  flexWrap: 'wrap',
  flex: '1 1 auto',
  justifyContent: 'flex-end'
})

// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
export const NewOrderButton = styled(Button)(({ theme }) => ({
  borderRadius: 8,
  textTransform: 'none',
  fontWeight: 500,
  padding: '8px 16px'
}))

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(even)': {
    backgroundColor: theme.palette.grey[50]
  },
  '&:hover': {
    backgroundColor: theme.palette.action.hover
  },
  '& td': {
    borderBottom: `1px solid ${theme.palette.grey[200]}`
  },
  '&.header-row': {
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  }
}))

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  backgroundColor: theme.palette.primary[99],
  fontWeight: 500,
  borderBottom: `1px solid ${theme.palette.grey[300]}`,
  padding: '12px 16px',
  '&.header-cell': {
    backgroundColor: theme.palette.primary[99]
  }
}))

export const CancelButton = styled(Button)(({ theme }) => ({
  borderRadius: 4,
  textTransform: 'none',
  fontSize: '0.75rem',
  padding: '2px 8px',
  minWidth: 'auto',
  borderColor: theme.palette.grey[400],
  color: theme.palette.text.primary,
  '&:hover': {
    borderColor: theme.palette.grey[600],
    backgroundColor: theme.palette.grey[100]
  }
}))
